const index = ({ children }) => children

export default index
